import { PropsWithChildren } from "react";
import { Box } from "@mui/material";

export const PHONE_WIDTH = 300;
export const PHONE_HEIGHT = 620;

export const PhoneFrame = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        width: PHONE_WIDTH + 20,
        height: PHONE_HEIGHT + 20,
        borderRadius: 6,
        backgroundColor: "#111",
        p: "10px",
        boxShadow: 6,
      }}
    >
      <Box
        sx={{
          width: PHONE_WIDTH,
          height: PHONE_HEIGHT,
          borderRadius: 4,
          overflow: "hidden",
          position: "relative",
          backgroundColor: "#000",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
